import React from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Box } from '@mui/material';
import { motion } from 'framer-motion';

const getChipColor = (level) => {
  if (level === 'High') return 'error';
  if (level === 'Medium') return 'warning';
  return 'success';
};

const IntentsTable = ({ data }) => {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 3, bgcolor: (theme) => theme.palette.mode === 'dark' ? 'grey.900' : 'grey.50' }}>
        <Typography variant="h6" gutterBottom>Top Conversation Intents</Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Intent</TableCell>
                <TableCell>Interactions</TableCell>
                <TableCell>Avg. Time</TableCell>
                <TableCell>Level</TableCell>
                <TableCell>Change</TableCell>
                <TableCell>Success</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row.intent}</TableCell>
                  <TableCell>{row.interactions.toLocaleString()}</TableCell>
                  <TableCell>{row.avgTime}</TableCell>
                  <TableCell><Chip label={row.level} color={getChipColor(row.level)} size="small" /></TableCell>
                  <TableCell sx={{ color: row.change >= 0 ? 'success.main' : 'error.main', fontWeight: 500 }}>{row.change > 0 ? '+' : ''}{row.change}%</TableCell>
                  <TableCell sx={{ color: 'success.main', fontWeight: 500 }}>{row.success}%</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </motion.div>
  );
};

export default IntentsTable; 